import BaseModel from "./base/baseModel";

export default class KitEmbalagemMoldeModel extends BaseModel {
    kitEmbalagemId?: number = null;
    moldeId?: number = null;
    moldeDescricao?: string = null;
    kitEmbalagemMoldePaiId: number = null;
    quantidade = 0;
}
